import { Card } from "@mui/material";
import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { useDispatch } from "react-redux";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { splitDocument } from "./splitDocumentSlice";
import { toast } from "react-toastify";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { t } from "i18next";

const SplitDocumentPage = ({
  document,
  numPages,
  onClose,
  setIsDocumentDivided,
}) => {
  const [selectedPages, setSelectedPages] = useState([]);

  const dispatch = useDispatch();

  const handlePageClick = (pageIndex) => {
    if (selectedPages.includes(pageIndex)) {
      setSelectedPages(selectedPages.filter((p) => p !== pageIndex));
    } else {
      setSelectedPages(
        [...selectedPages, pageIndex].sort(function (a, b) {
          return a - b;
        })
      );
    }
  };

  const handleSubmitSplit = (selectedPages) => {
    const breaksPage = selectedPages.toString();

    dispatch(splitDocument({ Id: document.id, Breaks: breaksPage })).then(
      (res) => {
        if (res.payload.Result === 1) {
          toast.success(t("DocSplitted"));
          if (setIsDocumentDivided) {
            setIsDocumentDivided((prevState) => ({
              ...prevState,
              [document.id]: true,
            }));
          }
        } else {
          toast.error(t("DocNotSplitted"));
        }
      }
    );
    onClose();
  };

  if (!document) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className="flex flex-col">
        <h2 className="text-center">{t("SplitDoc")}</h2>
        <h3 className="m-0">{t("SelectPagesForSplit")}</h3>
        <div className="flex justify-between items-center m-0">
          <div className="flex flex-col">
            {selectedPages && selectedPages.length > 0 ? (
              <p>
                {" "}
                {t("SelectPages")}:{" "}
                {selectedPages ? selectedPages.join(", ") : ""}
              </p>
            ) : (
              <p> {t("SelectPages")}: 0 </p>
            )}
          </div>
          <div>
            <CoreButton
              onClick={() => setSelectedPages([])}
              className="btn btn-round-outline me-3"
              color="primary"
              testo={"Reset "}
            />
            <CoreButton
              disabled={selectedPages.length === 0}
              onClick={() => handleSubmitSplit(selectedPages, numPages)}
              className="btn-round"
              testo={t("Confirm")}
            />
          </div>
        </div>
      </div>
      <div>
        <Document
          file={`${process.env.REACT_APP_API_URL}${document?.files[0]?.url}`}
        >
          <div className="flex flex-wrap ">
            {Array.from(new Array(numPages), (el, index) => (
              <Card
                elevation={4}
                key={`page_${index + 1}`}
                className={` text-center m-4 ${
                  selectedPages && selectedPages.includes(index + 1)
                    ? "bg-yellow-400"
                    : ""
                }`}
              >
                <div className=" text-center  ">
                  {selectedPages &&
                    selectedPages.includes(index + 1) &&
                    `${t("Interruction")} ${
                      selectedPages.indexOf(index + 1) + 1
                    }`}
                </div>
                <Page
                  width={350}
                  pageNumber={index + 1}
                  onClick={() => handlePageClick(index + 1)}
                  renderAnnotationLayer={false}
                />
                <div className="">{index + 1}</div>
              </Card>
            ))}
          </div>
        </Document>
      </div>
    </div>
  );
};

export default SplitDocumentPage;
